import { vaultPostRequest } from '../helpers';
import type { IGenerateSocialVideoRequest } from './generate-social-video-request';
import type { IGenerateSocialVideoResponse } from './generate-social-video-response';
import { generateSocialVideoResponseSchema } from './generate-social-video-response';

export async function generateSocialVideoApi(
  body: IGenerateSocialVideoRequest,
): Promise<IGenerateSocialVideoResponse> {
  return vaultPostRequest({
    path: '/social/generate',
    body,
    schema: generateSocialVideoResponseSchema,
  });
}
